
export default (state = {}, action)=>{
    switch (action.type) {
        case "set-default-english-locale":
            return action.data;
        default:
            return state;
    }
}
